import React, { useEffect, useState } from "react";
import { Button, Card, CardActions, CardContent, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEdicionSocio } from "../../../../context/socio/use-edicion-socio";
import EndPoints from "../../../../utils/services/EndPoints";
import Api from "../../../../utils/services/Api";
import AgregarContactoSection from "./AgregarContactoSection";
import ListaContactos from "./ListaContactos";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
  cardActions: {
    display: "flex",
    justifyContent: "space-between",
  },
  paperContainer: {
    padding: 16
  }
}));

const ContactoForm = () => {
  const {
    infoSocio: {
      datosBasicosMs: {
        codigoPersona
      }
    },
    goNextStep,
    goPreviousStep,
  } = useEdicionSocio()
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true)
  const [contactos, setContactos] = useState([])

  const getListaContactos = async () => {
    setLoading(true)
    try {
      const response = await Api(
        EndPoints.obtienePersonaTelefono + "/" + codigoPersona,
        "GET",
        null
      )
      setContactos(response)
      setLoading(false)
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" })
    }
  };

  useEffect(() => {
    getListaContactos();
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} position="relative">
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} component={Typography} variant="h5">
                Agregar contacto
              </Grid>
              <Grid item xs={12}>
                <AgregarContactoSection onSubmitted={getListaContactos} />
              </Grid>
              <Grid item xs={12} component={Typography} variant="h5">
                Contactos agregados
              </Grid>
              <Grid item xs={12}>
                <ListaContactos
                  contactos={contactos}
                  loading={loading}
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions
            classes={{
              root: classes.cardActions
            }}
          >
            <Button
              color="primary"
              onClick={goPreviousStep}
            >
              Atrás
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={goNextStep}
            >
              Siguiente
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ContactoForm;
